import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faChartPie, 
  faHistory, 
  faChartLine, 
  faBook, 
  faCommentAlt, 
  faMicrophone, 
  faCog, 
  faQuestionCircle, 
  faDisplay
} from '@fortawesome/free-solid-svg-icons';

const NAVIGATION_ITEMS = [
  {
    title: 'Main',
    items: [
      { id: 'dashboard', label: 'Dashboard', icon: faChartPie },
      { id: 'history', label: 'History', icon: faHistory },
      { id: 'knowledge-base', label: 'knowledge base', icon: faHistory },
      // { id: 'analytics', label: 'Analytics', icon: faChartLine },
      // { id: 'knowledgebase', label: 'Knowledgebase', icon: faBook },
    ]
  },
  {
    title: 'Testing',
    items: [
      { id: 'test-text-chat', label: 'Text Chat', icon: faCommentAlt },
      { id: 'test-voice-chat', label: 'Voice Chat', icon: faMicrophone },
      { id: 'demo-website', label: 'Demo Website', icon: faDisplay, isRoute: true, route: '/demowebsite' }
    ]
  },
  {
    title: 'Configuration',
    items: [
      { id: 'settings', label: 'Settings', icon: faCog },
      { id: 'support', label: 'Support', icon: faQuestionCircle }
    ]
  }
];

const Sidebar = ({ sidebarOpen, setSidebarOpen, activeTab, setActiveTab }) => {
  const navigate = useNavigate();

  const handleItemClick = (item) => {
    // Only check for Dashlane redirect when clicking on Demo Website
    if (item.id === 'demo-website') {
      const username = localStorage.getItem('user_name');
      console.log(username);
      console.log(username.includes('dashlane'));
      if (username && username.includes('dashlane')) {
        window.location.href = 'https://dashlaneinnext.netlify.app';
        return;
      }
    }

    if (item.isRoute) {
      navigate(item.route);
    } else {
      setActiveTab(item.id);
    }
  };

  const renderNavItem = (item) => (
    <a
      key={item.id}
      href="#"
      className={`flex items-center px-6 py-3 text-gray-300 hover:bg-gray-700 hover:text-white cursor-pointer ${
        activeTab === item.id ? 'bg-gray-700 text-white border-l-4 border-indigo-500' : ''
      }`}
      onClick={(e) => {
        e.preventDefault();
        handleItemClick(item);
      }}
    >
      <FontAwesomeIcon icon={item.icon} className="mr-3" />
      <span>{item.label}</span>
    </a>
  );

  const renderNavSection = (section) => (
    <div key={section.title}>
      <div className="px-4 py-2 mt-4 text-xs text-gray-400 uppercase tracking-wider">
        {section.title}
      </div>
      {section.items.map(renderNavItem)}
    </div>
  );

  return (
    <div className={`fixed inset-y-0 left-0 w-64 bg-gray-800 shadow-lg transform ${
      sidebarOpen ? 'translate-x-0' : '-translate-x-full'
    } transition-transform duration-300 ease-in-out md:translate-x-0 z-10`}>
      <div className="flex items-center justify-center h-16 border-b border-gray-700">
        <h1 className="text-xl font-bold text-white">Qurve AI</h1>
      </div>
      
      <nav className="mt-6">
        {NAVIGATION_ITEMS.map(renderNavSection)}
      </nav>
    </div>
  );
};

export default Sidebar;
